/*
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
 *
 * This file has been auto-generated. Any modifications
 * you make will be overwritten when the file is regenerated.
 *
 * For more information or questions, please go to #design-eng
 *
 */

/**
 * Typography CSS custom property references from Design Language 2.0.
 * Synced from Figma file: 5fZSvwd8naHgLN3UVZ5qFL
 *
 * Each export references vars defined in base-typography-v2.css.
 * Literal value counterparts live in typography.ts.
 */

import type { FontFamily, FontSize, LineHeight, FontWeight, LetterSpacing, MonoTypographyRampKey, TypographyRampKey, TypographyStyle } from './typography';
export type { FontFamily, FontSize, LineHeight, FontWeight, LetterSpacing, MonoTypographyRampKey, TypographyRampKey, TypographyStyle };

/** Font family tokens — CSS custom property references. */
export const fontFamiliesCssVars: Record<FontFamily, string> = ({
  body: 'var(--base-font-family-body)',
  display: 'var(--base-font-family-display)',
  mono: 'var(--base-font-family-mono)'
} as const);
export type FontFamiliesCssVarsType = typeof fontFamiliesCssVars;

/** Font size tokens — CSS custom property references. */
export const fontSizesCssVars: Record<FontSize, string> = ({
  10: 'var(--base-font-size-10)',
  12: 'var(--base-font-size-12)',
  14: 'var(--base-font-size-14)',
  16: 'var(--base-font-size-16)',
  18: 'var(--base-font-size-18)',
  20: 'var(--base-font-size-20)',
  22: 'var(--base-font-size-22)',
  24: 'var(--base-font-size-24)',
  28: 'var(--base-font-size-28)',
  32: 'var(--base-font-size-32)',
  36: 'var(--base-font-size-36)',
  42: 'var(--base-font-size-42)'
} as const);
export type FontSizesCssVarsType = typeof fontSizesCssVars;

/** Line height tokens — CSS custom property references. */
export const lineHeightsCssVars: Record<LineHeight, string> = ({
  10: 'var(--base-line-height-10)',
  12: 'var(--base-line-height-12)',
  14: 'var(--base-line-height-14)',
  16: 'var(--base-line-height-16)',
  18: 'var(--base-line-height-18)',
  20: 'var(--base-line-height-20)',
  24: 'var(--base-line-height-24)',
  28: 'var(--base-line-height-28)',
  32: 'var(--base-line-height-32)',
  36: 'var(--base-line-height-36)',
  42: 'var(--base-line-height-42)'
} as const);
export type LineHeightsCssVarsType = typeof lineHeightsCssVars;

/** Font weight tokens — CSS custom property references. */
export const fontWeightsCssVars: Record<FontWeight, string> = ({
  light: 'var(--base-font-weight-light)',
  regular: 'var(--base-font-weight-regular)',
  medium: 'var(--base-font-weight-medium)',
  bold: 'var(--base-font-weight-bold)'
} as const);
export type FontWeightsCssVarsType = typeof fontWeightsCssVars;

/** Letter spacing tokens — CSS custom property references. */
export const letterSpacingsCssVars: Record<LetterSpacing, string> = ({
  'ls-25': 'var(--base-letter-spacing-ls-25)',
  'ls-28': 'var(--base-letter-spacing-ls-28)',
  'ls-30': 'var(--base-letter-spacing-ls-30)',
  'ls-33': 'var(--base-letter-spacing-ls-33)',
  'ls-35': 'var(--base-letter-spacing-ls-35)',
  'ls-38': 'var(--base-letter-spacing-ls-38)',
  'ls-neg-5': 'var(--base-letter-spacing-ls-neg-5)'
} as const);
export type LetterSpacingsCssVarsType = typeof letterSpacingsCssVars;

/**
 * CSS custom property references for each typography ramp style.
 * The composite vars chain through base-typography-v2.css, where each one
 * references the corresponding primitive var (e.g. font-size → --base-font-size-N).
 */
export const typographyRampCssVars = (({
  bodyLMedium: {
    fontFamily: 'var(--base-typography-body-l-medium-font-family)',
    fontSize: 'var(--base-typography-body-l-medium-font-size)',
    lineHeight: 'var(--base-typography-body-l-medium-line-height)',
    fontWeight: 'var(--base-typography-body-l-medium-font-weight)',
    letterSpacing: 'var(--base-typography-body-l-medium-letter-spacing)'
  },
  bodyLRegular: {
    fontFamily: 'var(--base-typography-body-l-regular-font-family)',
    fontSize: 'var(--base-typography-body-l-regular-font-size)',
    lineHeight: 'var(--base-typography-body-l-regular-line-height)',
    fontWeight: 'var(--base-typography-body-l-regular-font-weight)',
    letterSpacing: 'var(--base-typography-body-l-regular-letter-spacing)'
  },
  bodyMMedium: {
    fontFamily: 'var(--base-typography-body-m-medium-font-family)',
    fontSize: 'var(--base-typography-body-m-medium-font-size)',
    lineHeight: 'var(--base-typography-body-m-medium-line-height)',
    fontWeight: 'var(--base-typography-body-m-medium-font-weight)',
    letterSpacing: 'var(--base-typography-body-m-medium-letter-spacing)'
  },
  bodyMRegular: {
    fontFamily: 'var(--base-typography-body-m-regular-font-family)',
    fontSize: 'var(--base-typography-body-m-regular-font-size)',
    lineHeight: 'var(--base-typography-body-m-regular-line-height)',
    fontWeight: 'var(--base-typography-body-m-regular-font-weight)',
    letterSpacing: 'var(--base-typography-body-m-regular-letter-spacing)'
  },
  bodySMedium: {
    fontFamily: 'var(--base-typography-body-s-medium-font-family)',
    fontSize: 'var(--base-typography-body-s-medium-font-size)',
    lineHeight: 'var(--base-typography-body-s-medium-line-height)',
    fontWeight: 'var(--base-typography-body-s-medium-font-weight)',
    letterSpacing: 'var(--base-typography-body-s-medium-letter-spacing)'
  },
  bodySRegular: {
    fontFamily: 'var(--base-typography-body-s-regular-font-family)',
    fontSize: 'var(--base-typography-body-s-regular-font-size)',
    lineHeight: 'var(--base-typography-body-s-regular-line-height)',
    fontWeight: 'var(--base-typography-body-s-regular-font-weight)',
    letterSpacing: 'var(--base-typography-body-s-regular-letter-spacing)'
  },
  headlineLBold: {
    fontFamily: 'var(--base-typography-headline-l-bold-font-family)',
    fontSize: 'var(--base-typography-headline-l-bold-font-size)',
    lineHeight: 'var(--base-typography-headline-l-bold-line-height)',
    fontWeight: 'var(--base-typography-headline-l-bold-font-weight)',
    letterSpacing: 'var(--base-typography-headline-l-bold-letter-spacing)'
  },
  headlineLMedium: {
    fontFamily: 'var(--base-typography-headline-l-medium-font-family)',
    fontSize: 'var(--base-typography-headline-l-medium-font-size)',
    lineHeight: 'var(--base-typography-headline-l-medium-line-height)',
    fontWeight: 'var(--base-typography-headline-l-medium-font-weight)',
    letterSpacing: 'var(--base-typography-headline-l-medium-letter-spacing)'
  },
  headlineLRegular: {
    fontFamily: 'var(--base-typography-headline-l-regular-font-family)',
    fontSize: 'var(--base-typography-headline-l-regular-font-size)',
    lineHeight: 'var(--base-typography-headline-l-regular-line-height)',
    fontWeight: 'var(--base-typography-headline-l-regular-font-weight)',
    letterSpacing: 'var(--base-typography-headline-l-regular-letter-spacing)'
  },
  headlineMBold: {
    fontFamily: 'var(--base-typography-headline-m-bold-font-family)',
    fontSize: 'var(--base-typography-headline-m-bold-font-size)',
    lineHeight: 'var(--base-typography-headline-m-bold-line-height)',
    fontWeight: 'var(--base-typography-headline-m-bold-font-weight)',
    letterSpacing: 'var(--base-typography-headline-m-bold-letter-spacing)'
  },
  headlineMMedium: {
    fontFamily: 'var(--base-typography-headline-m-medium-font-family)',
    fontSize: 'var(--base-typography-headline-m-medium-font-size)',
    lineHeight: 'var(--base-typography-headline-m-medium-line-height)',
    fontWeight: 'var(--base-typography-headline-m-medium-font-weight)',
    letterSpacing: 'var(--base-typography-headline-m-medium-letter-spacing)'
  },
  headlineMRegular: {
    fontFamily: 'var(--base-typography-headline-m-regular-font-family)',
    fontSize: 'var(--base-typography-headline-m-regular-font-size)',
    lineHeight: 'var(--base-typography-headline-m-regular-line-height)',
    fontWeight: 'var(--base-typography-headline-m-regular-font-weight)',
    letterSpacing: 'var(--base-typography-headline-m-regular-letter-spacing)'
  },
  headlineSBold: {
    fontFamily: 'var(--base-typography-headline-s-bold-font-family)',
    fontSize: 'var(--base-typography-headline-s-bold-font-size)',
    lineHeight: 'var(--base-typography-headline-s-bold-line-height)',
    fontWeight: 'var(--base-typography-headline-s-bold-font-weight)',
    letterSpacing: 'var(--base-typography-headline-s-bold-letter-spacing)'
  },
  headlineSMedium: {
    fontFamily: 'var(--base-typography-headline-s-medium-font-family)',
    fontSize: 'var(--base-typography-headline-s-medium-font-size)',
    lineHeight: 'var(--base-typography-headline-s-medium-line-height)',
    fontWeight: 'var(--base-typography-headline-s-medium-font-weight)',
    letterSpacing: 'var(--base-typography-headline-s-medium-letter-spacing)'
  },
  headlineSRegular: {
    fontFamily: 'var(--base-typography-headline-s-regular-font-family)',
    fontSize: 'var(--base-typography-headline-s-regular-font-size)',
    lineHeight: 'var(--base-typography-headline-s-regular-line-height)',
    fontWeight: 'var(--base-typography-headline-s-regular-font-weight)',
    letterSpacing: 'var(--base-typography-headline-s-regular-letter-spacing)'
  },
  headlineXlBold: {
    fontFamily: 'var(--base-typography-headline-xl-bold-font-family)',
    fontSize: 'var(--base-typography-headline-xl-bold-font-size)',
    lineHeight: 'var(--base-typography-headline-xl-bold-line-height)',
    fontWeight: 'var(--base-typography-headline-xl-bold-font-weight)',
    letterSpacing: 'var(--base-typography-headline-xl-bold-letter-spacing)'
  },
  headlineXlMedium: {
    fontFamily: 'var(--base-typography-headline-xl-medium-font-family)',
    fontSize: 'var(--base-typography-headline-xl-medium-font-size)',
    lineHeight: 'var(--base-typography-headline-xl-medium-line-height)',
    fontWeight: 'var(--base-typography-headline-xl-medium-font-weight)',
    letterSpacing: 'var(--base-typography-headline-xl-medium-letter-spacing)'
  },
  headlineXlRegular: {
    fontFamily: 'var(--base-typography-headline-xl-regular-font-family)',
    fontSize: 'var(--base-typography-headline-xl-regular-font-size)',
    lineHeight: 'var(--base-typography-headline-xl-regular-line-height)',
    fontWeight: 'var(--base-typography-headline-xl-regular-font-weight)',
    letterSpacing: 'var(--base-typography-headline-xl-regular-letter-spacing)'
  },
  headlineXsBold: {
    fontFamily: 'var(--base-typography-headline-xs-bold-font-family)',
    fontSize: 'var(--base-typography-headline-xs-bold-font-size)',
    lineHeight: 'var(--base-typography-headline-xs-bold-line-height)',
    fontWeight: 'var(--base-typography-headline-xs-bold-font-weight)',
    letterSpacing: 'var(--base-typography-headline-xs-bold-letter-spacing)'
  },
  headlineXsMedium: {
    fontFamily: 'var(--base-typography-headline-xs-medium-font-family)',
    fontSize: 'var(--base-typography-headline-xs-medium-font-size)',
    lineHeight: 'var(--base-typography-headline-xs-medium-line-height)',
    fontWeight: 'var(--base-typography-headline-xs-medium-font-weight)',
    letterSpacing: 'var(--base-typography-headline-xs-medium-letter-spacing)'
  },
  headlineXsRegular: {
    fontFamily: 'var(--base-typography-headline-xs-regular-font-family)',
    fontSize: 'var(--base-typography-headline-xs-regular-font-size)',
    lineHeight: 'var(--base-typography-headline-xs-regular-line-height)',
    fontWeight: 'var(--base-typography-headline-xs-regular-font-weight)',
    letterSpacing: 'var(--base-typography-headline-xs-regular-letter-spacing)'
  },
  headlineXxsBold: {
    fontFamily: 'var(--base-typography-headline-xxs-bold-font-family)',
    fontSize: 'var(--base-typography-headline-xxs-bold-font-size)',
    lineHeight: 'var(--base-typography-headline-xxs-bold-line-height)',
    fontWeight: 'var(--base-typography-headline-xxs-bold-font-weight)',
    letterSpacing: 'var(--base-typography-headline-xxs-bold-letter-spacing)'
  },
  headlineXxsMedium: {
    fontFamily: 'var(--base-typography-headline-xxs-medium-font-family)',
    fontSize: 'var(--base-typography-headline-xxs-medium-font-size)',
    lineHeight: 'var(--base-typography-headline-xxs-medium-line-height)',
    fontWeight: 'var(--base-typography-headline-xxs-medium-font-weight)',
    letterSpacing: 'var(--base-typography-headline-xxs-medium-letter-spacing)'
  },
  headlineXxsRegular: {
    fontFamily: 'var(--base-typography-headline-xxs-regular-font-family)',
    fontSize: 'var(--base-typography-headline-xxs-regular-font-size)',
    lineHeight: 'var(--base-typography-headline-xxs-regular-line-height)',
    fontWeight: 'var(--base-typography-headline-xxs-regular-font-weight)',
    letterSpacing: 'var(--base-typography-headline-xxs-regular-letter-spacing)'
  }
} as const) satisfies Record<TypographyRampKey, TypographyStyle>);
export type TypographyRampCssVarsType = typeof typographyRampCssVars;

/**
 * CSS custom property references for each mono typography ramp style.
 * The vars are defined in base-typography-v2.css under the mono-* prefix.
 */
export const monoTypographyRampCssVars = (({
  monoBodyLMedium: {
    fontFamily: 'var(--base-typography-mono-body-l-medium-font-family)',
    fontSize: 'var(--base-typography-mono-body-l-medium-font-size)',
    lineHeight: 'var(--base-typography-mono-body-l-medium-line-height)',
    fontWeight: 'var(--base-typography-mono-body-l-medium-font-weight)',
    letterSpacing: 'var(--base-typography-mono-body-l-medium-letter-spacing)'
  },
  monoBodyLRegular: {
    fontFamily: 'var(--base-typography-mono-body-l-regular-font-family)',
    fontSize: 'var(--base-typography-mono-body-l-regular-font-size)',
    lineHeight: 'var(--base-typography-mono-body-l-regular-line-height)',
    fontWeight: 'var(--base-typography-mono-body-l-regular-font-weight)',
    letterSpacing: 'var(--base-typography-mono-body-l-regular-letter-spacing)'
  },
  monoBodyMMedium: {
    fontFamily: 'var(--base-typography-mono-body-m-medium-font-family)',
    fontSize: 'var(--base-typography-mono-body-m-medium-font-size)',
    lineHeight: 'var(--base-typography-mono-body-m-medium-line-height)',
    fontWeight: 'var(--base-typography-mono-body-m-medium-font-weight)',
    letterSpacing: 'var(--base-typography-mono-body-m-medium-letter-spacing)'
  },
  monoBodyMRegular: {
    fontFamily: 'var(--base-typography-mono-body-m-regular-font-family)',
    fontSize: 'var(--base-typography-mono-body-m-regular-font-size)',
    lineHeight: 'var(--base-typography-mono-body-m-regular-line-height)',
    fontWeight: 'var(--base-typography-mono-body-m-regular-font-weight)',
    letterSpacing: 'var(--base-typography-mono-body-m-regular-letter-spacing)'
  },
  monoBodySMedium: {
    fontFamily: 'var(--base-typography-mono-body-s-medium-font-family)',
    fontSize: 'var(--base-typography-mono-body-s-medium-font-size)',
    lineHeight: 'var(--base-typography-mono-body-s-medium-line-height)',
    fontWeight: 'var(--base-typography-mono-body-s-medium-font-weight)',
    letterSpacing: 'var(--base-typography-mono-body-s-medium-letter-spacing)'
  },
  monoBodySRegular: {
    fontFamily: 'var(--base-typography-mono-body-s-regular-font-family)',
    fontSize: 'var(--base-typography-mono-body-s-regular-font-size)',
    lineHeight: 'var(--base-typography-mono-body-s-regular-line-height)',
    fontWeight: 'var(--base-typography-mono-body-s-regular-font-weight)',
    letterSpacing: 'var(--base-typography-mono-body-s-regular-letter-spacing)'
  },
  monoHeadlineLBold: {
    fontFamily: 'var(--base-typography-mono-headline-l-bold-font-family)',
    fontSize: 'var(--base-typography-mono-headline-l-bold-font-size)',
    lineHeight: 'var(--base-typography-mono-headline-l-bold-line-height)',
    fontWeight: 'var(--base-typography-mono-headline-l-bold-font-weight)',
    letterSpacing: 'var(--base-typography-mono-headline-l-bold-letter-spacing)'
  },
  monoHeadlineLMedium: {
    fontFamily: 'var(--base-typography-mono-headline-l-medium-font-family)',
    fontSize: 'var(--base-typography-mono-headline-l-medium-font-size)',
    lineHeight: 'var(--base-typography-mono-headline-l-medium-line-height)',
    fontWeight: 'var(--base-typography-mono-headline-l-medium-font-weight)',
    letterSpacing: 'var(--base-typography-mono-headline-l-medium-letter-spacing)'
  },
  monoHeadlineLRegular: {
    fontFamily: 'var(--base-typography-mono-headline-l-regular-font-family)',
    fontSize: 'var(--base-typography-mono-headline-l-regular-font-size)',
    lineHeight: 'var(--base-typography-mono-headline-l-regular-line-height)',
    fontWeight: 'var(--base-typography-mono-headline-l-regular-font-weight)',
    letterSpacing: 'var(--base-typography-mono-headline-l-regular-letter-spacing)'
  },
  monoHeadlineMBold: {
    fontFamily: 'var(--base-typography-mono-headline-m-bold-font-family)',
    fontSize: 'var(--base-typography-mono-headline-m-bold-font-size)',
    lineHeight: 'var(--base-typography-mono-headline-m-bold-line-height)',
    fontWeight: 'var(--base-typography-mono-headline-m-bold-font-weight)',
    letterSpacing: 'var(--base-typography-mono-headline-m-bold-letter-spacing)'
  },
  monoHeadlineMMedium: {
    fontFamily: 'var(--base-typography-mono-headline-m-medium-font-family)',
    fontSize: 'var(--base-typography-mono-headline-m-medium-font-size)',
    lineHeight: 'var(--base-typography-mono-headline-m-medium-line-height)',
    fontWeight: 'var(--base-typography-mono-headline-m-medium-font-weight)',
    letterSpacing: 'var(--base-typography-mono-headline-m-medium-letter-spacing)'
  },
  monoHeadlineMRegular: {
    fontFamily: 'var(--base-typography-mono-headline-m-regular-font-family)',
    fontSize: 'var(--base-typography-mono-headline-m-regular-font-size)',
    lineHeight: 'var(--base-typography-mono-headline-m-regular-line-height)',
    fontWeight: 'var(--base-typography-mono-headline-m-regular-font-weight)',
    letterSpacing: 'var(--base-typography-mono-headline-m-regular-letter-spacing)'
  },
  monoHeadlineSBold: {
    fontFamily: 'var(--base-typography-mono-headline-s-bold-font-family)',
    fontSize: 'var(--base-typography-mono-headline-s-bold-font-size)',
    lineHeight: 'var(--base-typography-mono-headline-s-bold-line-height)',
    fontWeight: 'var(--base-typography-mono-headline-s-bold-font-weight)',
    letterSpacing: 'var(--base-typography-mono-headline-s-bold-letter-spacing)'
  },
  monoHeadlineSMedium: {
    fontFamily: 'var(--base-typography-mono-headline-s-medium-font-family)',
    fontSize: 'var(--base-typography-mono-headline-s-medium-font-size)',
    lineHeight: 'var(--base-typography-mono-headline-s-medium-line-height)',
    fontWeight: 'var(--base-typography-mono-headline-s-medium-font-weight)',
    letterSpacing: 'var(--base-typography-mono-headline-s-medium-letter-spacing)'
  },
  monoHeadlineSRegular: {
    fontFamily: 'var(--base-typography-mono-headline-s-regular-font-family)',
    fontSize: 'var(--base-typography-mono-headline-s-regular-font-size)',
    lineHeight: 'var(--base-typography-mono-headline-s-regular-line-height)',
    fontWeight: 'var(--base-typography-mono-headline-s-regular-font-weight)',
    letterSpacing: 'var(--base-typography-mono-headline-s-regular-letter-spacing)'
  },
  monoHeadlineXlBold: {
    fontFamily: 'var(--base-typography-mono-headline-xl-bold-font-family)',
    fontSize: 'var(--base-typography-mono-headline-xl-bold-font-size)',
    lineHeight: 'var(--base-typography-mono-headline-xl-bold-line-height)',
    fontWeight: 'var(--base-typography-mono-headline-xl-bold-font-weight)',
    letterSpacing: 'var(--base-typography-mono-headline-xl-bold-letter-spacing)'
  },
  monoHeadlineXlMedium: {
    fontFamily: 'var(--base-typography-mono-headline-xl-medium-font-family)',
    fontSize: 'var(--base-typography-mono-headline-xl-medium-font-size)',
    lineHeight: 'var(--base-typography-mono-headline-xl-medium-line-height)',
    fontWeight: 'var(--base-typography-mono-headline-xl-medium-font-weight)',
    letterSpacing: 'var(--base-typography-mono-headline-xl-medium-letter-spacing)'
  },
  monoHeadlineXlRegular: {
    fontFamily: 'var(--base-typography-mono-headline-xl-regular-font-family)',
    fontSize: 'var(--base-typography-mono-headline-xl-regular-font-size)',
    lineHeight: 'var(--base-typography-mono-headline-xl-regular-line-height)',
    fontWeight: 'var(--base-typography-mono-headline-xl-regular-font-weight)',
    letterSpacing: 'var(--base-typography-mono-headline-xl-regular-letter-spacing)'
  },
  monoHeadlineXsBold: {
    fontFamily: 'var(--base-typography-mono-headline-xs-bold-font-family)',
    fontSize: 'var(--base-typography-mono-headline-xs-bold-font-size)',
    lineHeight: 'var(--base-typography-mono-headline-xs-bold-line-height)',
    fontWeight: 'var(--base-typography-mono-headline-xs-bold-font-weight)',
    letterSpacing: 'var(--base-typography-mono-headline-xs-bold-letter-spacing)'
  },
  monoHeadlineXsMedium: {
    fontFamily: 'var(--base-typography-mono-headline-xs-medium-font-family)',
    fontSize: 'var(--base-typography-mono-headline-xs-medium-font-size)',
    lineHeight: 'var(--base-typography-mono-headline-xs-medium-line-height)',
    fontWeight: 'var(--base-typography-mono-headline-xs-medium-font-weight)',
    letterSpacing: 'var(--base-typography-mono-headline-xs-medium-letter-spacing)'
  },
  monoHeadlineXsRegular: {
    fontFamily: 'var(--base-typography-mono-headline-xs-regular-font-family)',
    fontSize: 'var(--base-typography-mono-headline-xs-regular-font-size)',
    lineHeight: 'var(--base-typography-mono-headline-xs-regular-line-height)',
    fontWeight: 'var(--base-typography-mono-headline-xs-regular-font-weight)',
    letterSpacing: 'var(--base-typography-mono-headline-xs-regular-letter-spacing)'
  },
  monoHeadlineXxsBold: {
    fontFamily: 'var(--base-typography-mono-headline-xxs-bold-font-family)',
    fontSize: 'var(--base-typography-mono-headline-xxs-bold-font-size)',
    lineHeight: 'var(--base-typography-mono-headline-xxs-bold-line-height)',
    fontWeight: 'var(--base-typography-mono-headline-xxs-bold-font-weight)',
    letterSpacing: 'var(--base-typography-mono-headline-xxs-bold-letter-spacing)'
  },
  monoHeadlineXxsMedium: {
    fontFamily: 'var(--base-typography-mono-headline-xxs-medium-font-family)',
    fontSize: 'var(--base-typography-mono-headline-xxs-medium-font-size)',
    lineHeight: 'var(--base-typography-mono-headline-xxs-medium-line-height)',
    fontWeight: 'var(--base-typography-mono-headline-xxs-medium-font-weight)',
    letterSpacing: 'var(--base-typography-mono-headline-xxs-medium-letter-spacing)'
  },
  monoHeadlineXxsRegular: {
    fontFamily: 'var(--base-typography-mono-headline-xxs-regular-font-family)',
    fontSize: 'var(--base-typography-mono-headline-xxs-regular-font-size)',
    lineHeight: 'var(--base-typography-mono-headline-xxs-regular-line-height)',
    fontWeight: 'var(--base-typography-mono-headline-xxs-regular-font-weight)',
    letterSpacing: 'var(--base-typography-mono-headline-xxs-regular-letter-spacing)'
  }
} as const) satisfies Record<MonoTypographyRampKey, TypographyStyle>);
export type MonoTypographyRampCssVarsType = typeof monoTypographyRampCssVars;